module.exports = __webpack_public_path__ + "static/media/hoc2.3a921181.jpg";